import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const deleteWine = async (wineId: number | string): Promise<any> => {
  const res = await axiosSecure.delete(`${getContextRoot()}/wine/${wineId}`);
  return res.data;
};

export default deleteWine;
